import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';
import Select from 'flarum/common/components/Select';

import InviteCodeAddSuccessModal from './InviteCodeAddSuccessModal';

export default class InviteCodeAddExtensionModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.inviteCodeData = this.attrs.inviteCodeData;
    this.loading = false;
    this.u2di_userType = Stream("0");
    this.u2di_validDuration = Stream(366);
    
    const _this = this;
  }

  className() {
    return 'Modal--small';
  }

  onready() {
    const _this = this;
    $('input[type=radio][name=option_validDuration]').on('change', function() {
      _this.u2di_validDuration(parseInt($(this).val()));
    });
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-add-invite-code-extension');
  }

  content() {
    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div>
            <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                {app.translator.trans('ziven-u2di.forum.signup-field-user-type')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <Select className="u2diDataSelectList" value={this.u2di_userType()}
                  options={{
                    "0":app.translator.trans('ziven-u2di.forum.user-type-0'),
                  }}
                  onchange={(e) => {
                    this.u2di_userType(e);
                  }}
                />
              </div>
            </div>

            <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                {app.translator.trans('ziven-u2di.forum.signup-field-valid-date')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <div style="display: flex;height: 40px;align-items: center;">
                  <div><input disabled={this.loading} id="inviteCodeDuration1" type="radio" name="option_validDuration" value="366" checked={this.u2di_validDuration()==366?"checked":""} /><label style="margin-left: 5px;" for="inviteCodeDuration1">{app.translator.trans('ziven-u2di.lib.duration-366')}</label></div>
                  <div style="margin-left:10px"><input disabled={this.loading} id="inviteCodeDuration2" type="radio" name="option_validDuration" value="1098" checked={this.u2di_validDuration()==1098?"checked":""} /><label style="margin-left: 5px;" for="inviteCodeDuration2">{app.translator.trans('ziven-u2di.lib.duration-1098')}</label></div>
                  <div style="margin-left:10px"><input disabled={this.loading} id="inviteCodeDuration3" type="radio" name="option_validDuration" value="1830" checked={this.u2di_validDuration()==1830?"checked":""} /><label style="margin-left: 5px;" for="inviteCodeDuration3">{app.translator.trans('ziven-u2di.lib.duration-1830')}</label></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                type: 'submit'
              },
              app.translator.trans('ziven-u2di.lib.confirm')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    $(".Modal-close").hide();

    const codeType = 1;
    const submitData = {
      userType:this.u2di_userType(),
      validDuration:this.u2di_validDuration(),
      codeType:codeType,
    };

    app.store
      .createRecord("u2diInviteCode")
      .save(submitData)
      .then((result) => {
          app.store.pushPayload(result);
          app.modal.show(InviteCodeAddSuccessModal,{codeType});
          $(window).trigger('u2diInviteCodeAdd');
        }
      )
      .catch((e) => {
        this.loading = false;
      });
  }
}
